import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Rating from "@mui/material/Rating";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";
export default function ProductDiscReviews({ ListOfUsersReview }) {
  const { t, i18n } = useTranslation();
  const [page, setPage] = useState(1);
  const itemsPerPage = 28; // Display 12 items per page for better pagination

  // Handle pagination page changes
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: MyWidth >= 1024 ? "80%" : "100%",
        marginTop: 50,
      }}
    >
      {ListOfUsersReview.map((item, index) => {
        const FirstChar = item.fullName
          ? item.fullName.charAt(0).toUpperCase()
          : "";
        return (
          <div>
            <div
              style={{
                height: "0.1px",
                backgroundColor: "#f4f4f5",
                width: "100%",
              }}
            ></div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                marginTop: 40,
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  //paddingTop: 10,
                  width: "30%",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    color: "white",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "18px",
                    fontWeight: "bold",
                    backgroundColor: "#f4f4f5",
                  }}
                >
                  {FirstChar}
                </div>

                <a key={index}>&nbsp; &nbsp;{item.fullName}</a>
              </div>
              <div
                style={{
                  display: "flex",
                  width: "70%",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Rating
                    name="read-only"
                    value={item.rating}
                    readOnly
                    sx={{
                      // Make stars bigger
                      fontSize: "0.75rem", // Adjust size (e.g., 1.5rem, 2rem, etc.)

                      // Add space between stars
                      "& .MuiRating-icon": {
                        color: "black", // Black stars
                        paddingRight: "0 2px", // Adjust spacing (e.g., 0 8px for more space)
                        paddingTop: 1,
                      },

                      // Ensure filled/hover stars are also black
                      "& .MuiRating-iconFilled": {
                        color: "black",
                      },
                      "& .MuiRating-iconHover": {
                        color: "black",
                      },
                    }}
                  />
                  <a
                    style={{
                      fontSize: 14,
                    }}
                  >
                    {item.theDate}
                  </a>
                </div>
                <p
                  style={{
                    margin: 0,

                    paddingTop: 40,
                  }}
                >
                  {item.comment}
                </p>
              </div>
            </div>
          </div>
        );
      })}

      <Stack spacing={2} alignItems="center" marginTop={4}>
        <Pagination
          count={Math.ceil(ListOfUsersReview.length / itemsPerPage)}
          page={page}
          onChange={handlePageChange}
          color="primary"
          hidePrevButton
          hideNextButton
          sx={{
            "& .MuiPaginationItem-root": {
              borderRadius: "0px", // Make buttons square
              "&:hover": {
                backgroundColor: "black", // Hover background color
                color: "white", // Optional text color on hover
              },
              "&.Mui-selected": {
                backgroundColor: "black", // Background color when clicked
                color: "white", // Text color when clicked
              },
            },
          }}
        />
      </Stack>
    </div>
  );
}
